import { EmptyHeader } from '../../../components/Header/EmptyHeader';
import { Header } from '../../../components/Header/Header';
import { IRoute } from '../IRoute';

const HeaderRoutes: IRoute[] = [
  // Common routes
  {
    actions: ['events'],
    component: EmptyHeader,
    key: '/',
    path: '/'
  },
  {
    actions: [],
    component: EmptyHeader,
    key: '/login',
    path: '/login'
  },
  {
    actions: [],
    component: EmptyHeader,
    key: '/start',
    path: '/start'
  },
  // Player routes
  {
    actions: [],
    component: EmptyHeader,
    key: '/register/*',
    path: '/register/*',
    scope: 'guest'
  },
  // Admin routes
  {
    actions: [],
    component: EmptyHeader,
    key: '/staff',
    path: '/staff'
  },
  {
    actions: [],
    component: EmptyHeader,
    key: '/staff/login',
    path: '/staff/login'
  },
  {
    actions: [],
    component: EmptyHeader,
    key: '/requestResetPassword',
    path: '/requestResetPassword'
  },
  {
    actions: [],
    component: EmptyHeader,
    key: '/staff/requestResetPassword',
    path: '/staff/requestResetPassword'
  },
  {
    actions: [],
    component: EmptyHeader,
    key: '/password/reset/:uid/:token',
    path: '/password/reset/:uid/:token'
  },
  {
    actions: [],
    component: EmptyHeader,
    key: '/staff/club/:clubID/home',
    path: '/staff/club/:clubID/home'
  },
  {
    actions: [],
    component: EmptyHeader,
    key: '/staff/club/create/*',
    path: '/staff/club/create/*',
    scope: 'guest'
  },
  {
    actions: ['clubs', 'adminClubs', 'seasons', 'user', 'events'],
    component: Header,
    key: '/staff/club/:clubId/event/:eventId/*',
    path: '/staff/club/:clubId/event/:eventId/*'
  },
  {
    actions: ['clubs', 'adminClubs', 'seasons', 'user', 'events'],
    component: Header,
    key: '/staff/club/:clubId/*',
    path: '/staff/club/:clubId/*'
  },
  {
    actions: ['clubs', 'adminClubs', 'seasons', 'user', 'events'],
    component: Header,
    key: '/staff/home',
    path: '/staff/home'
  },
  {
    actions: ['clubs', 'adminClubs', 'seasons', 'user', 'pages', 'events'],
    component: Header,
    key: '/club/:clubId/*',
    path: '/club/:clubId/*'
  },
  {
    actions: ['clubs', 'adminClubs', 'seasons', 'user', 'events'],
    component: Header,
    key: '/*',
    path: '/*'
  },
  {
    actions: ['clubs', 'adminClubs', 'seasons', 'user', 'events'],
    component: Header,
    key: '/staff/settings/*',
    path: '/staff/settings/*'
  },
  {
    actions: ['clubs', 'adminClubs', 'seasons', 'user', 'events'],
    component: Header,
    key: '/staff/*',
    path: '/staff/*'
  }
];

export default HeaderRoutes;
